import { render, staticRenderFns } from "./TicketCreate.vue?vue&type=template&id=c62f859a&scoped=true"
import script from "./TicketCreate.vue?vue&type=script&lang=js"
export * from "./TicketCreate.vue?vue&type=script&lang=js"
import style0 from "./TicketCreate.vue?vue&type=style&index=0&id=c62f859a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c62f859a",
  null
  
)

export default component.exports